
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'whitespace-nowrap cursor-pointer font-medium transition-all duration-300 hover:scale-105';
  
  const variants = {
    primary: 'bg-[#6D03F4] text-white hover:shadow-lg hover:shadow-[#6D03F4]/30 hover:bg-[#5A02D1]',
    secondary: 'bg-[#007FFF] text-white hover:shadow-lg hover:shadow-[#007FFF]/30 hover:bg-[#0066CC]',
    outline: 'border-2 border-[#6D03F4] text-[#6D03F4] hover:bg-[#6D03F4] hover:text-white'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm rounded-lg',
    md: 'px-6 py-3 text-base rounded-xl',
    lg: 'px-8 py-4 text-lg rounded-xl'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
